import { timeFormatter } from "./timeFormatter";
var DateUtil = /** @class */ (function () {
    function DateUtil() {
    }
    DateUtil.prototype.minutesToDisplayTime = function (min) {
        min = Math.trunc(min);
        var date = new Date();
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        date.setHours(min / 60, min % 60, 0);
        return timeFormatter.format(date);
    };
    return DateUtil;
}());
export { DateUtil };
export var dateUtil = new DateUtil();
